export default "__VITE_ASSET__zQeG9lJN__"